import {BenchlingAction} from 'redux-stores/Action';
import {BenchlingState} from 'redux-stores/reduceApp';

import {ManagedModelTypes} from './ManagedModelDefinitions';
import {ManagedModelsActionTypes} from './ManagedModelsReduxActions';

export type ManagedModelsState = {
  [modelType in keyof ManagedModelTypes]?: {
    [modelKey: string]: ManagedModelTypes[modelType];
  };
};

export const MANAGED_MODELS_INITIAL_STATE: ManagedModelsState = {};

export class ManagedModelSelector {
  constructor(readonly state: BenchlingState) {}

  getModel<T extends keyof ManagedModelTypes>(modelType: T, modelKey: string): ManagedModelTypes[T] | null {
    const modelsByKey = this.state.models.managed[modelType];
    if (!modelsByKey) {
      return null;
    }

    return modelsByKey[modelKey] || null;
  }

  // Currently only used for GraphQL - probably consult Alan/Damon before using for real code
  getAllModelsByKey<T extends keyof ManagedModelTypes>(modelType: T): {[key: string]: ManagedModelTypes[T]} {
    const modelsByKey = this.state.models.managed[modelType]!;
    // Force a cast to avoid an overly-complex union, and because this is technically unsafe if T is a union
    // of strings, but that's obscure enought that we ignore.
    return (modelsByKey as unknown as {[key: string]: ManagedModelTypes[T]}) || {};
  }
}

export default function reduceManagedModels(
  state: ManagedModelsState = MANAGED_MODELS_INITIAL_STATE,
  action: BenchlingAction
): ManagedModelsState {
  switch (action.type) {
    case ManagedModelsActionTypes.MODEL_FETCHED:
      return {
        ...state,
        [action.modelType]: {
          ...state[action.modelType],
          ...action.modelsByKey,
        },
      };
    default:
      return state;
  }
}
